import { Pipe, PipeTransform } from '@angular/core';
import { LeagueEvents} from '@model';
import { TranslocoService } from '@ngneat/transloco';

@Pipe({
    name: 'leagueNextRound',
    standalone: false
})
export class LeagueNextRoundPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform = (leagueEvents?: LeagueEvents, mode: 'single' | 'ratio' | 'index' = 'single'): any => {
    const totalRounds = leagueEvents?.totalRounds ?? leagueEvents?.total ?? 0;
    const round = leagueEvents?.nextRound?.round ?? 0;

    if (mode === 'index') {
      return round;
    }

    if (mode === 'ratio') {
      return this.translocoService.translate('league.round.of', { round: round, totalRounds: totalRounds});
    }

    return this.translocoService.translate('league.round', { value: round });
  }

}
